// Assign device kit modal — optional carer ID and/or patient ID.

import { useState } from "react";
import type { JSX } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../lib/api.js";

export function AssignKitModal({ kitId, onClose, onSuccess }: {
  kitId: string;
  onClose: () => void;
  onSuccess: () => void;
}): JSX.Element {
  const [carerId, setCarerId] = useState("");
  const [patientId, setPatientId] = useState("");
  const qc = useQueryClient();

  const assign = useMutation({
    mutationFn: () => apiFetch(`/device-kits/${kitId}/assign`, {
      method: "POST",
      body: JSON.stringify({ assigned_to_carer_id: carerId || null, assigned_to_patient_id: patientId || null }),
    }),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ["device-kits"] }); onSuccess(); },
  });

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-sm">
        <h2 className="text-lg font-semibold text-slate-900 mb-4">Assign Device Kit</h2>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Carer ID (optional)</label>
            <input className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
              value={carerId} onChange={(e) => setCarerId(e.target.value)} placeholder="Enter carer UUID" />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Patient ID (optional)</label>
            <input className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
              value={patientId} onChange={(e) => setPatientId(e.target.value)} placeholder="Enter patient UUID" />
          </div>
        </div>
        {assign.isError && <p className="mt-2 text-xs text-red-600">Failed to assign kit.</p>}
        <div className="mt-5 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-slate-600 hover:text-slate-900">Cancel</button>
          <button onClick={() => assign.mutate()} disabled={assign.isPending}
            className="px-4 py-2 text-sm bg-navy-700 text-white rounded-lg hover:bg-navy-800 disabled:opacity-50">
            {assign.isPending ? "Assigning…" : "Assign"}
          </button>
        </div>
      </div>
    </div>
  );
}
